module.exports = __webpack_public_path__ + "static/14-4958fea78440a116866148dea818931c.jpg";